import { Flex, FlexProps } from "@chakra-ui/react";

export function VerticalLayout({ children, ...rest }: FlexProps) {
  return (
    <Flex w="100%" flexDirection="column" {...rest}>
      {children}
    </Flex>
  );
}
